import { render, staticRenderFns } from "./editParkingArea.vue?vue&type=template&id=c2b95a42"
import script from "./editParkingArea.vue?vue&type=script&lang=js"
export * from "./editParkingArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports